export default __webpack_public_path__ + "static/media/lenovo.b0f22f8b.svg";